import styled from 'styled-components';
import {shade} from 'polished';
import { Context } from '../../Context/ThemeContext';
import IconButton from '@material-ui/core/IconButton';

import useAuth from '../../Context/hooks/useAuth';

import history from '../../history';

import { AiOutlineHome } from 'react-icons/ai';
import { ImUsers } from 'react-icons/im';
import { SiAzureartifacts } from 'react-icons/si';

import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import MenuNavegacaoItem from './MenuNavegacaoItem';

import { useState } from 'react';

const MenuContainer =  styled.div`
    z-index: 999;
    position:absolute;
    left: 0;
    top: 0;
    width: ${props => props.aberto? "190px" : "50px"};
    background: ${props => props.theme.colors.primary};
    height: 100%;
    transition: width .1s linear;
    padding: 55px 0px 0px 0px;

    .menu-container{
        position:absolute;
        top: 9px;
        right: 4px;
        
        svg{
            font-size: 136%;
            color: ${props => props.theme.colors.text};
        }
    }
    overflow-x: hidden;

    /* background-image: url("../../../assets/imagens/impulso-network.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    background-attachment: fixed; */

`;

const MenuItem =  styled.li`
    cursor: pointer;
   
    display: flex;
    align-items: center;
    padding: .7rem .3rem;
    margin: 0;
    transition: background .2s ease-in;
    position: relative;
    
    border-left: 7px solid ${props => props.theme.colors.primary};

    color: ${props => props.theme.colors.text};

    :hover,  &.ativo{
        border-color: ${props => shade(0.2, props.theme.colors.secundary)};
        background: ${props => props.theme.colors.secundary};
    }

    svg{
        flex-shrink: 0;
        font-size: 30px;
    }

    p{
        
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        margin:0;
        margin-left: 15px;
        font-size: 80%;

        position: absolute;
        transition: all .2s ease-out;
        left: ${props => !props.aberto? "120px" : "38px"};

        
    }
`;


const Menu = ({className}) => {

    const [aberto, setAberto] = useState(false)

    const handleMenu = () => {
        setAberto(!aberto);
    }

    const handleLink = (evt, link) => {
        let el = evt.target
       
        let menu = el.closest("ul");
        let menuAtivo = menu.getElementsByClassName('ativo');
        // console.log(menu);
        if(menuAtivo[0]){
            menuAtivo[0].classList.remove('ativo');
        }

        let linkClicado = el.closest("li");
        linkClicado.classList.add('ativo');

        history.push(link)
        setAberto(false);
    }


	return(
		<MenuContainer className={className} aberto={aberto}>
            <div className="menu-container">
                <IconButton className="p-1" onClick={handleMenu}>
                    {aberto ? <ChevronLeftIcon /> : <MenuIcon/>}
                </IconButton>
            </div>
            <ul>
                {MenuNavegacaoItem.map((menuItens, index) => (
                    <MenuItem aberto={aberto} key={menuItens.link} onClick={(evt) => handleLink(evt, menuItens.link)} > {menuItens.icone}<p>{menuItens.titulo}</p></MenuItem>
                ))}
            </ul>
        </MenuContainer>
	)
}

export default Menu
